<div fxLayout="column" fxLayoutAlign="start start" class="layout margin">
  <pre>{{getJson() | json}}</pre>
</div>
